import React from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const About = () => {
  const { currentTheme } = useTheme();
  
  return (
    <section className={`py-20 px-6 ${currentTheme.colors.background}`}>
      <div className="max-w-6xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className={`text-4xl md:text-5xl font-bold ${currentTheme.colors.text} mb-6`}>
            Why I Do What I Do
          </h2>
          <div className={`w-24 h-1 bg-${currentTheme.colors.accent} mx-auto mb-8`}></div>
        </motion.div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            whileHover={{ scale: 1.05 }}
          >
            <img 
              src="/images/profile2.png" 
              alt="Mukesh Rathore" 
              className="rounded-lg shadow-2xl object-cover w-full h-auto"
            />
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            <p className="text-xl text-gray-700 leading-relaxed font-semibold">
              I’m Mukesh Rathore — an artist-turned-mentor who believes singers are meant to become original artists, not just cover performers.
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              I’ve seen many talented singers struggle because they didn’t know:
            </p>
            
            <ul className="space-y-3 text-lg text-gray-700">
              <li className="flex items-start gap-3">
                <span className="text-purple-600 font-bold">•</span>
                <span>How to shape ideas into songs</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-purple-600 font-bold">•</span>
                <span>Where to begin</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-purple-600 font-bold">•</span>
                <span>What steps to follow</span>
              </li>
            </ul>
            
            <p className="text-lg text-gray-700 leading-relaxed font-semibold">
              That’s why I created a simple, practical system to help singers move from humming melodies to creating, producing, and releasing their own original songs —
with clarity, confidence, and direction.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
